import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { RevokeClientInvitationMutationResponse, RevokeClientInvitationPathParams, RevokeClientInvitation404 } from "../types/RevokeClientInvitation";
import type { UseMutationOptions } from "@tanstack/react-query";

 type RevokeClientInvitationClient = typeof client<RevokeClientInvitationMutationResponse, RevokeClientInvitation404, never>;
type RevokeClientInvitation = {
    data: RevokeClientInvitationMutationResponse;
    error: RevokeClientInvitation404;
    request: never;
    pathParams: RevokeClientInvitationPathParams;
    queryParams: never;
    headerParams: never;
    response: RevokeClientInvitationMutationResponse;
    client: {
        parameters: Partial<Parameters<RevokeClientInvitationClient>[0]>;
        return: Awaited<ReturnType<RevokeClientInvitationClient>>;
    };
};
/**
 * @description Revokes a given invitation, if it exists for the client.
 * @summary Revoke
 * @link /api/clients/:clientCode/invitations/:invitationId
 */
export function useRevokeClientInvitation(clientCode: RevokeClientInvitationPathParams["clientCode"], invitationId: RevokeClientInvitationPathParams["invitationId"], options: {
    mutation?: UseMutationOptions<RevokeClientInvitation["response"], RevokeClientInvitation["error"], RevokeClientInvitation["request"]>;
    client?: RevokeClientInvitation["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async () => {
            const res = await client<RevokeClientInvitation["data"], RevokeClientInvitation["error"], RevokeClientInvitation["request"]>({
                method: "delete",
                url: `/api/clients/${clientCode}/invitations/${invitationId}`,
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}